import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Button } from 'reactstrap';
import { IColumn } from '../../../components/ui/DataGrid';
import { getRankingReportExportData } from '../../RankingReportCreationContainer/lib/utils';
import { getRankingReportPdfExport } from './pdfExport';
import {getColumnNamesList, getIndustryAvgPosition, getRollupPositions} from './utils';

export function ExportOptionsComponent(props: {
  onClick: () => void;
  pdfReady: boolean;
  reportName: string;
  columns: Array<IColumn<any>>;
  rankColumns: any[];
  nColumns: any[];
  records: any[];
  // @ts-ignore
  rankingReportColumns: IColumn[];
  prop8: ({ url, loading }: { url: any; loading: any }) => JSX.Element;
  precisionColumns?: any
}) {
  return (
    <div>
      <Button className="btn btn-info right ml-4" onClick={props.onClick}>
        Export CSV
      </Button>
      {props.pdfReady && (
        <BlobProvider
          document={getRankingReportPdfExport(
            props.reportName,
            getRankingReportExportData(
              props.columns,
              props.rankColumns,
              props.nColumns,
              props.records,
              getColumnNamesList(props.rankingReportColumns),
                props.precisionColumns
            ),
            getRollupPositions(props.records),
            getIndustryAvgPosition(props.records)
          )}
        >
          {props.prop8}
        </BlobProvider>
      )}
    </div>
  );
}
